var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.groups),function(group){return _c('tr',{key:group.id},[_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(group.pivot.role === 'group_owner'
								? 'Owner'
								: group.pivot.role === 'group_member'
								? 'Member'
								: group.pivot.role)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.owner_name))])])}),0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',[_vm._v("Role")]),_vm._v(" "),_c('th',[_vm._v("Groups")]),_vm._v(" "),_c('th',[_vm._v("Owner")])])])
}]

export { render, staticRenderFns }